import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_PATHS } from '../config/api-paths';
import { SmeConsentsApi } from '../tokens/sme-consents.token';
import { ConsentRow, ConsentAction, ConsentResult } from '../models/sme-consent.model';

/** The dedicated SCA header (never `Authorization`). */
const SCA_TOKEN_HEADER = 'X-SCA-Token';

/**
 * REST-only implementation of `SmeConsentsApi` (Story E / EM-472, PR-04 / §5.4 / §9.1).
 *
 * Calls (party-scoped):
 *   GET  /services/embedded/api/parties/{partyId}/consents
 *   POST /services/embedded/api/parties/{partyId}/consents  (+ X-SCA-Token: gdpr_consent for GDPR)
 *
 * Rides the Keycloak bearer (`authInterceptor`). The SCA token is attached only when present
 * (GDPR grant/revoke); PSD2 / T&C / Marketing carry none. Rule 07 / Rule 10 — no Mock.
 */
@Injectable()
export class SmeConsentsRestService implements SmeConsentsApi {
  private readonly http = inject(HttpClient);
  private readonly base = API_PATHS.PARTIES;

  list(partyId: number): Observable<ConsentRow[]> {
    return this.http.get<ConsentRow[]>(`${this.base}/${partyId}/consents`);
  }

  apply(partyId: number, action: ConsentAction, scaToken: string | null): Observable<ConsentResult> {
    const options = scaToken
      ? { headers: new HttpHeaders().set(SCA_TOKEN_HEADER, scaToken) }
      : {};
    return this.http.post<ConsentResult>(`${this.base}/${partyId}/consents`, action, options);
  }
}
